import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledSubHeading = styled.div`
  h4 {
    font-weight: 600;

    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 25px;
    padding: 6px 5px;
  }
`

export const SubHeading = ({ subHeading, children }: { subHeading: string; children?: ReactNode }) => {
  return (
    <StyledSubHeading>
      <h4>
        {subHeading}
        {children}
      </h4>
    </StyledSubHeading>
  )
}
